// SelectYourRoleStep2.js
import { Box, Typography } from "@mui/material";
import MainContentReUse from "./MainContentReUse";
import TextFieldWithHeading from "./TextFieldWithHeading";
import { useState } from "react";
import api from "../../config/axios";

const roleTextFieldData = [
  { heading: "Role", placeholder: "Select Your Role" },
];

function SelectYourRoleStep2({ onSuccess }) {
  const [role, setRole] = useState(""); // local state for role

  const handleRoleChange = (e) => setRole(e.target.value);

  // We'll call /api/auth/role
  const handleNext = async () => {
    try {
      // If role is empty, handle accordingly. Or set a default "creator" etc.
      if (!role) {
        alert("Please enter or select a role before continuing.");
        return;
      }

      await api.put("/auth/role", { role });
      // Then go to next step
      onSuccess();
    } catch (err) {
      console.error("Role update error:", err);
      alert(err?.response?.data?.message || "Error updating role");
    }
  };

  return (
    <MainContentReUse
      primaryText="Select Your Role"
      primaryButton={{ exist: true, text: "Next Step" }}
      secondaryText="Please choose a role that best describes you."
      buttonsBelowText={{ exist: true, text: "Thank you for selecting your role!" }}
      onClick={handleNext}
    >
      <Box sx={{ pt: "34px" }}>
        {roleTextFieldData.map((data) => (
          <TextFieldWithHeading
            key={data.heading}
            heading={data.heading}
            placeholder={data.placeholder}
            value={role}
            onChange={handleRoleChange} // add this
          />
        ))}
        <Typography
          variant="body2"
          sx={{
            fontSize: "17px",
            fontWeight: "400",
            lineHeight: "20.57px",
          }}
        >
          Select the role that best describes you.
        </Typography>
      </Box>
    </MainContentReUse>
  );
}

export default SelectYourRoleStep2;
